<!-- <navigation *ngIf="showNavigation"></navigation>
<simple-app-widget *ngIf="!showNavigation"></simple-app-widget> -->

@if(showNavigation){
<navigation></navigation>
}@else{
@if(currentBookingType == "simple"){
<app-simple-widget></app-simple-widget>
} @else if(currentBookingType == "advanced"){
<app-advanced-widget></app-advanced-widget>
} @else if(currentBookingType == "short-term"){
<app-short-term-widget></app-short-term-widget>
} @else if(currentBookingType == "aiden-short-term"){
<app-aiden-short-term-widget></app-aiden-short-term-widget>
} @else if(currentBookingType == "park-and-fly-advanced"){
<app-park-and-fly-advanced-widget></app-park-and-fly-advanced-widget>
} @else if(currentBookingType == "aiden-park-and-fly-advanced"){
<app-aiden-park-and-fly-advanced-widget></app-aiden-park-and-fly-advanced-widget>
}
}